import React, { useEffect, useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import hamburger from '../../assets/icons/black-hamburger.svg';
import { environment } from '../../environments/environment';
import Pagination from '@mui/material/Pagination';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { ICampaignAdmin } from '../../models/admin/campaigns';
import { FormattedDate, IntlProvider } from 'react-intl';
import api from '../../api/api';
import { toast } from 'react-toastify';

interface ProductImagesProps {
  product_uuid: string;
  media_url: string;
}

export const AdminProducts = () => {
  const [products, setProducts] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [productImages, setProductImages] = useState<ProductImagesProps[] | null>(null);

  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts(currentPage);
  }, [currentPage]);

  const fetchProducts = async (page: number) => {
    try {
      // const response = await api.get(
      //   `${environment.baseUrl}/admin/products?page=${page}`)

      const response = await api.get(`${environment.baseUrl}/product/fetch/list?page=${page}&sort`)

      const productImages = response.data.data.product_images;

      const extractedImages = Object.entries(productImages)
        .filter(
          ([product_uuid, images]) =>
            (images as { product_uuid: string; media_url: string }[]).length > 0
      )
        .map(([product_uuid, images]) => {
          const firstImage = (images as { product_uuid: string; media_url: string }[])[0];

          const cloudinaryImageUrl = firstImage.media_url.includes('cloudinary.com')
            ? firstImage.media_url.replace(
                '/upload/',
                '/upload/w_250,h_169,c_fill,f_auto,c_lpad,b_auto:predominant/'
              )
            : firstImage.media_url;
          
          return {
            product_uuid: firstImage.product_uuid,
            media_url: cloudinaryImageUrl,
          };
        });
      
      setProductImages(extractedImages);
      setProducts(response.data.data?.products?.rows ?? null);
      setTotalPages(response.data.data?.products?.total_pages ?? 1);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }

  const deleteProduct = async (uuid: string) => {
    try {
      const response = await api.delete(
        `${environment.baseUrl}/admin/product/delete/${uuid}`
      );
      if (response.data.success) {
        toast.success('Product deleted successfully!');
        fetchProducts(currentPage);
      } else {
        toast.error('Failed to delete product!');
      }
    } catch (error) {
      toast.error('Error deleting product!');
    }
  }

  function handlePageChange(event: React.ChangeEvent<unknown>, page: number) {
      setCurrentPage(page);
    }
  
  return (
    <section className="font-montserrat">
      <IntlProvider locale="en">
        <div className="flex items-center flex-wrap gap-6 justify-between">
          <div className="flex items-center gap-3">
            <img src={hamburger} alt="hamburger" className="w-6 h-6" />
            <h1 className="text-2xl font-bold">Products</h1>
          </div>

          <div className="flex items-center gap-3 ml-auto">
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              variant="outlined"
              shape="rounded"
            />
            <Link to="/admin/products/new">
              <button className="bg-[#0E203F] text-white flex items-center gap-2 p-2 rounded-md  focus:outline-none focus:shadow-outline transform transition duration-300 perspective-origin-center hover:-rotate-y-6 hover:scale-105 active:rotate-y-180 active:scale-100">
                <FiPlus />
                <span>ADD NEW PRODUCT</span>
              </button>
            </Link>
          </div>
        </div>
      
        
        <div className="mt-7 bg-white text-[#0E203F] p-4 md:p-8 tall:py-[60px] xl:px-9 rounded-[12px] md:rounded-[18px]">
          {products ? (
            <>
              {products.map((product:any, index:number) => {
                const productImage = productImages?.find(
                  (image) => image.product_uuid === product.uuid
                );

                return (
                  <div
                    key={product.uuid}
                    className={`grid gap-6 lg:grid-cols-[250px_auto_1fr] xl:gap-10  ${
                      index === 0 ? "" : " mt-5"
                    }`}
                  >
                    <div className="aspect-[245/165] ">
                      <Link to={`/admin/products/${product.uuid}`}>
                        <img
                          // src={productImage?.media_url || bottle}
                          src={productImage?.media_url}
                          alt="Product"
                          className="w-full h-full object-cover object-top"
                        />
                      </Link>
                    </div>

                    <div className="">
                      <h4 className="font-bold text-[22px]">
                        {product.product_title}
                      </h4>
                      <p className="font-bold text-sm mt-2">250% funded</p>
                      <p className="text-sm mt-2">By Robyn</p>

                      <div className="mt-2 flex gap-4">
                        <Link to={`/admin/products/${product.uuid}`}>
                          <span className="underline font-medium hover:font-bold text-sm">
                            View
                          </span>
                        </Link>
                        <button
                          onClick={() => deleteProduct(product.uuid)}
                           className="text-red-600 underline font-medium hover:font-bold text-sm"
                        >
                          Delete
                        </button>
                      </div>
                    </div>

                    <div className="overflow-x">
                      <table className="w-full whitespace-nowrap">
                        <thead>
                          <tr>
                            <th className="text-left font-normal pb-7">
                              <FormattedDate
                                value={product.CreatedAt}
                                year="numeric"
                                month="short"
                                day="2-digit"
                              />
                            </th>
                            <th className="text-left pl-5 font-normal pb-7">
                              LOCATION
                            </th>
                            <th className="text-left pl-5 font-normal pb-7">
                              STATUS
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-t border-solid border-t-black">
                            <td className="pt-7">
                              FEB 20, 2025
                            </td>
                            <td className="pt-7 pl-5">
                              {product.location}
                            </td>
                            <td className="pt-7 pl-5">
                              <div className="py-1 px-5 text-center w-fit mr-auto text-sm bg-[#0E203F] text-white
                              leading-[14px] rounded-[13px]">
                                ACTIVE
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )
              })}

              <div className="mt-4 flex justify-center">
                              <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handlePageChange}
                                variant="outlined"
                                shape="rounded"
                              />
                            </div>
            </>
          ) : (
              <>
                            <Stack spacing={1}>
                              <Stack spacing={1} direction={"row"}>
                                <Skeleton variant="rounded" width={210} height={60} />
                                <Skeleton variant="rounded" width={410} height={60} />
                                <Skeleton variant="rounded" width={1100} height={60} />
                              </Stack>
                              <Stack spacing={1} direction={"row"}>
                                <Skeleton variant="rounded" width={210} height={60} />
                                <Skeleton variant="rounded" width={410} height={60} />
                                <Skeleton variant="rounded" width={1100} height={60} />
                              </Stack>
                            </Stack>
                          </>
        )}
        </div>
</IntlProvider>
    </section>
  )

}